import type { Config } from '@/types/config';

let config: Config | null = null;

export function setConfig(cfg: Config) {
    config = cfg;
}

export function getConfig() {
    if (!config) {
        throw new Error('Config is not initialized.');
    }

    return config;
}
